import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import WPCOMTestimonial from './wpcomtestimonial'

class WPCOMCompleted extends React.Component {
	message = () => {
		const { migrate } = this.props
		if (migrate.getIn(['destination_site_resp', 'error_class']) == "BV::WordpressSiteCriticalError") {
			return (
				<React.Fragment>
					<p>
						Your migration was a success, but your migrated site is encountering a critical error. It happens!
							&nbsp;<a href="https://wordpress.com/support/request-a-migration/" className="dark-link" target="_blank" rel="noreferrer">Contact Support</a> to get help fixing those up.
					</p>
				</React.Fragment>
			)
		} else {
			return (
				<React.Fragment>
					<p>The finish line is close! We&apos;ve emailed you at <b>{migrate.get('email')}</b> with the final steps to complete the process.</p>
					<p>Take a look at your site and let us know if anything looks off by replying to the email we sent you.</p>
				</React.Fragment>
			)
		}
	}
	render() {
		const { migrate } = this.props
		return <div className="wpcom">
			<div className="wpcom-migration-container">
				<main className="wpcom-migration-content">
					<h1>Your site has been migrated to WordPress.com</h1>
					{this.message()}
					<div className="wpcom-migration-form">
						<div className="wpcom-migration-section">
							<button type="button" onClick={() => (window.location.href = migrate.get('destination_site'))}>Review your new site</button>
						</div>
					</div>
				</main>
				<WPCOMTestimonial migrate={migrate} />
			</div>
		</div>
	}
}

WPCOMCompleted.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default WPCOMCompleted
